<table mat-table class="table-fixed table-status" [dataSource]="clusters">

  <!-- Code -->
  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef>{{ 'code' | translate }}</th>
    <td mat-cell *matCellDef="let cluster">
      {{ cluster.shortCode }}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Name -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>{{ 'cluster' | translate }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span class="text-ellipsis-2 a" (click)="goToCluster(cluster._id)">
        {{ cluster.name }}
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Surface -->
  <ng-container matColumnDef="surface">
    <th mat-header-cell *matHeaderCellDef>{{ 'surface' | translate }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span [class.muted]="!cluster.customValues?.surface"
        matTooltip="
          {{ (cluster.customValues?.surface * 100) / totals.surface | number: '1.0-1' }}% 
          {{ 'ofTotal' | translate: 'pluralLowerCase' }} {{ 'surface' | translate: 'lowerCase' }}"
        matTooltipPosition="above">
        {{ cluster.customValues?.surface | number: '1.0-1' }}
        <span class="muted">m<sup>2</sup></span>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!totals.surface">
      {{ totals.surface | number: '1.0-1' }}
      <span class="muted">m<sup>2</sup></span>
    </td>
  </ng-container>

  <!-- FNO -->
  <ng-container matColumnDef="fno">
    <th mat-header-cell *matHeaderCellDef>{{ 'fno' | translate: 'upperCase' }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span [class.muted]="!cluster.customValues?.fno"
        matTooltip="
          {{ (cluster.customValues?.fno * 100) / totals.fno | number: '1.0-1' }}% 
          {{ 'ofTotal' | translate: 'pluralLowerCase' }} {{ 'fno' | translate: 'upperCase' }}"
        matTooltipPosition="above">
        {{ cluster.customValues?.fno | number: '1.0-1' }}
        <span class="muted">m<sup>2</sup></span>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!totals.fno">
      {{ totals.fno | number: '1.0-1' }}
      <span class="muted">m<sup>2</sup></span>
    </td>
  </ng-container>

  <!-- Ratio -->
  <ng-container matColumnDef="ratio">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ratio' | translate }} {{ 'bvo' | translate: 'upperCase' }}/{{ 'fno' | translate: 'upperCase' }}
    </th>
    <td mat-cell *matCellDef="let cluster" [class.muted]="!cluster.ratio">
      {{ cluster.ratio || 0 | number: '1.0-2' }}
      <!-- <span class="muted">/1</span> -->
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!building.ratio">
      {{ building.ratio || 0 | number: '1.0-2' }}
      <!-- <span class="muted">/1</span> -->
    </td>
  </ng-container>

  <!-- BVO -->
  <ng-container matColumnDef="bvo">
    <th mat-header-cell *matHeaderCellDef>{{ 'bvo' | translate: 'upperCase' }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span [class.muted]="!cluster.customValues?.bvo"
        matTooltip="
          {{ (cluster.customValues?.bvo * 100) / totals.bvo | number: '1.0-1' }}% 
          {{ 'ofTotal' | translate: 'pluralLowerCase' }} {{ 'bvo' | translate: 'upperCase' }}"
        matTooltipPosition="above">
        {{ cluster.customValues?.bvo | number: '1.0-1' }}
        <span class="muted">m<sup>2</sup></span>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!totals.bvo">
      {{ totals.bvo | number: '1.0-1' }}
      <span class="muted">m<sup>2</sup></span>
    </td>
  </ng-container>

  <!-- NFNO -->
  <ng-container matColumnDef="nfno">
    <th mat-header-cell *matHeaderCellDef>{{ 'nfno' | translate: 'upperCase' }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span [class.muted]="!cluster.customValues?.nfno"
        matTooltip="
          {{ (cluster.customValues?.nfno * 100) / totals.nfno | number: '1.0-1' }}% 
          {{ 'ofTotal' | translate: 'pluralLowerCase' }} {{ 'nfno' | translate: 'upperCase' }}"
        matTooltipPosition="above">
        {{ cluster.customValues?.nfno | number: '1.0-1' }}
        <span class="muted">m<sup>2</sup></span>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!totals.nfno">
      {{ totals.nfno | number: '1.0-1' }}
      <span class="muted">m<sup>2</sup></span>
    </td>
  </ng-container>

  <!-- SAN -->
  <ng-container matColumnDef="san">
    <th mat-header-cell *matHeaderCellDef>{{ 'san' | translate: 'upperCase' }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span [class.muted]="!cluster.customValues?.san"
        matTooltip="
          {{ (cluster.customValues?.san * 100) / totals.san | number: '1.0-1' }}% 
          {{ 'ofTotal' | translate: 'pluralLowerCase' }} {{ 'san' | translate: 'upperCase' }}"
        matTooltipPosition="above">
        {{ cluster.customValues?.san | number: '1.0-1' }}
        <span class="muted">m<sup>2</sup></span>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!totals.san">
      {{ totals.san | number: '1.0-1' }}
      <span class="muted">m<sup>2</sup></span>
    </td>
  </ng-container>

  <!-- VER -->
  <ng-container matColumnDef="ver">
    <th mat-header-cell *matHeaderCellDef>{{ 'ver' | translate: 'upperCase' }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span [class.muted]="!cluster.customValues?.ver"
        matTooltip="
          {{ (cluster.customValues?.ver * 100) / totals.ver | number: '1.0-1' }}% 
          {{ 'ofTotal' | translate: 'pluralLowerCase' }} {{ 'ver' | translate: 'upperCase' }}"
        matTooltipPosition="above">
        {{ cluster.customValues?.ver | number: '1.0-1' }}
        <span class="muted">m<sup>2</sup></span>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!totals.ver">
      {{ totals.ver | number: '1.0-1' }}
      <span class="muted">m<sup>2</sup></span>
    </td>
  </ng-container>

  <!-- BUI -->
  <ng-container matColumnDef="bui">
    <th mat-header-cell *matHeaderCellDef>{{ 'bui' | translate: 'upperCase' }}</th>
    <td mat-cell *matCellDef="let cluster">
      <span [class.muted]="!cluster.customValues?.bui"
        matTooltip="
          {{ (cluster.customValues?.bui * 100) / totals.bui | number: '1.0-1' }}% 
          {{ 'ofTotal' | translate: 'pluralLowerCase' }} {{ 'bui' | translate: 'upperCase' }}"
        matTooltipPosition="above">
        {{ cluster.customValues?.bui | number: '1.0-1' }}
        <span class="muted">m<sup>2</sup></span>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef [class.muted]="!totals.bui">
      {{ totals.bui | number: '1.0-1' }}
      <span class="muted">m<sup>2</sup></span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns; let cluster"
    [ngStyle]="{ 'border-left': '10px solid ' + cluster.color }"></tr>
  <tr mat-footer-row *matFooterRowDef="tableColumns"></tr>

</table> 
